// Détermine l'état d'affichage (icône + tooltip + accessibilité) à partir du statut antivirus d'un document
export function getAntivirusIndicator(antivirusStatus, antivirusThreats) {
  switch (antivirusStatus) {
    case "ok":
      return { disabled: false, emoji: null, tooltip: null };
    case "infected": {
      const threatsList = Array.isArray(antivirusThreats)
        ? antivirusThreats.join(", ")
        : antivirusThreats;
      return {
        disabled: true,
        emoji: "⚠️",
        tooltip: `Ce document est infecté par un ou plusieurs virus (${threatsList}) et ne peut pas être ouvert.`,
      };
    }
    // "new", "failed" et tout statut inconnu/absent sont traités de la même façon
    default:
      return {
        disabled: true,
        emoji: "🔄",
        tooltip: "Analyse antivirus en cours…",
      };
  }
}
